<!-- App.vue -->
<template>
  <v-app>
    <app-toolbar />
    <v-main>
      <router-view />
    </v-main>
    <app-bottom-nav />
    <SnowOverlay v-if="letItSnow"/>
    <cookie-consent-banner />
    <v-snackbar v-model="snackbarVisible" :color="snackbarColor" top right>
      {{ snackbarMessage }}
      <v-progress-circular
        v-if="snackbarColor === SnackbarType.LOADING"
        :indeterminate="true"
        rounded
        height="6" />
    </v-snackbar>
  </v-app>
</template>

<script lang="ts" setup>
import GlobalService from "@/services/global-service";
import AppToolbar from "@/components/AppToolbar.vue";
import SnackbarType from "@/types/enums/snackbar-type";
import CookieConsentBanner from "@/components/CookieConsentBanner.vue";
import AppBottomNav from "@/views/AppBottomNav.vue";
import useStore from "@/stores";
import {computed, onMounted} from "vue";
import SnowOverlay from "@/components/SnowOverlay.vue";

const { chatwoot } = useStore();

const snackbarVisible = GlobalService.snackbar().snackbarVisible;
const snackbarMessage = GlobalService.snackbar().snackbarMessage;
const snackbarColor = GlobalService.snackbar().snackbarColor;

enum Month {
  JANUARY = 0,
  DECEMBER = 11
}

const letItSnow = computed<boolean>(() => {
  const month: number = new Date().getMonth();

  return month === Month.DECEMBER || month === Month.JANUARY;
});

onMounted(async () => {
  await chatwoot.init();
});

</script>

<style lang="scss">
@import "@/assets/scss/main.scss";
</style>
